import React, { Component } from 'react';
import Switch from '../../Part_Sample/Switch';
import Top_Bar from '../../Part_Sample/Top_Bar';
import { isEmpty } from '../../Common/common';

export default class Interlock extends Component {
	constructor(props) {
		super(props);
		window.app.hideLoading();
		// App may crash if interlock is null
		let programs = {};
		if (!isEmpty(this.props.param.interlock)) {
			if (!isEmpty(this.props.param.interlock.program)) programs = this.props.param.interlock.program;
		}

		this.state = {
			programs: programs,
		}
	}

	handlePrevious = () => {
		window.app.content_area.current.switch_content.current.handleShowBottomMenu();
		this.props.content_handler('System');
	}

	handleEditInterlock = (program_id) => {
		this.props.content_handler('Interlock_Summary', { program_id: program_id, schedule: this.props.param.schedule, scenes: this.props.param.scenes, interlock: this.props.param.interlock, groups: this.props.param.groups });
	}

	handleAddInterlock = () => {
		this.props.content_handler('Interlock_Summary', { program_id: null, schedule: this.props.param.schedule, scenes: this.props.param.scenes, interlock: this.props.param.interlock, groups: this.props.param.groups });
	}

	handleToggleEnable = (program_id) => {
		let program = {};
		let programs = this.state.programs;
		program[program_id] = JSON.parse(JSON.stringify(programs[program_id]));
		program[program_id].exec = !program[program_id].exec;
		//this.props.receiver.modifyInterlockProgram(program);

		let commandTmp = {};
		commandTmp[program_id] = {enable: program[program_id].exec};
		this.props.receiver.enableInterlockProgram(commandTmp);

		programs[program_id].exec = !programs[program_id].exec;
		this.setState({ programs: programs });
	}

	rcvModifyInterlockProgram(response) {
		if (response.result == 'OK') {

		} else {
			window.app.showToast(this.props.receiver.getString('set_fail'), 3000);
		}
	}

	rcvEnableInterlockProgram(response) {
		if (response.result == 'OK') {

		} else {
			window.app.showToast(this.props.receiver.getString('set_fail'), 3000);
		}
	}

	render() {
		let style = {
			textAlign: 'center',
			width: '100%',
		}

		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			height: this.props.height,
		}

		let button_style = {
			cursor: 'pointer',
			width: this.props.width - 40,
			backgroundColor: 'white',
			marginTop: 10,
			marginLeft: 'auto',
			marginRight: 'auto',
			borderRadius: 20,
			textAlign: 'left',
			boxShadow: '1px 1px 2px 2px rgba(0, 0, 0, 0.1)',
		}

		return (
			<div style={style}>
				<div id='main_content' style={main_content_style} className='slideInDown noScrollBar'>
					<Top_Bar
						width={this.props.width}
						title={this.props.receiver.getString('interlock')}
						left_button_type={'back'}
						handleLeftButton={this.handlePrevious}
						right_button_type={'add'}
						handleRightButton={this.handleAddInterlock}
					/>
					<div style={{ height: this.props.height - 140, paddingBottom: 60, overflow: 'auto' }}>
						{Object.keys(this.state.programs).map((program_id) => {
							let program = this.state.programs[program_id];
							return (
								<div style={button_style} >
									<div style={{ display: 'inline-block', width: this.props.width - 120, textAlign: 'left', verticalAlign: 'top', marginLeft: 10, marginRight: 10, paddingTop: 15, paddingBottom: 15 }} onClick={() => this.handleEditInterlock(program_id)}>
										<span>{program.name}</span>
									</div>
									<div style={{ display: 'inline-block', width: 20, marginTop: 10 }}>
										<Switch style={{ display: 'inline-block' }} is_enabled={program.exec} handleToggleSwitch={() => this.handleToggleEnable(program_id)} />
									</div>
								</div>
							)
						})}
					</div>
				</div>
			</div>
		)
	}
}